import { get, isEmpty, isString } from 'lodash';
import { debug } from 'debug';

export class Logger {
  #log = debug('TagManagerJS');

  constructor(options = {}) {
    if (isString(options)) {
      options = { prefix: options };
    }

    if (options.prefix) {
      this.#log = this.#log.extend(options.prefix);
    }
  }

  warn(...message) {
    this.#log(...message);
  }

  debug(...message) {
    this.#log(...message);
  }

  debugEvent(eventType, ...message) {
    this.debug(`event:${eventType}`, ...message);
  }

  withPrefix(prefix) {
    return new Logger({ prefix });
  }
}
